/**
 * Custom error for lock conflicts (HTTP 409).
 * Thrown by service methods when the backend reports a resource is locked by another operator.
 */
export class LockConflictError extends Error {
  public readonly lockedBy: string;
  public readonly resourceType: string;
  public readonly resourceId: string | number;

  constructor(lockedBy: string, resourceType: string, resourceId: string | number) {
    super(`${resourceType} ${resourceId} er låst av ${lockedBy}`);
    this.name = 'LockConflictError';
    this.lockedBy = lockedBy;
    this.resourceType = resourceType;
    this.resourceId = resourceId;
  }
}

/**
 * Checks a fetch response for a 409 LOCK_CONFLICT error and throws LockConflictError if found.
 * Should be called before generic error handling in service methods.
 */
export async function throwIfLockConflict(response: Response): Promise<void> {
  if (response.status === 409) {
    const body = await response.json().catch(() => ({}));
    const details = body.details || {};
    throw new LockConflictError(
      details.lockedBy || 'ukjent',
      details.resourceType || 'Ressurs',
      details.resourceId || ''
    );
  }
}
